import {
    ButtonProps,
    Group,
    Text
} from "@mantine/core";

import {
    Field,
    Form,
    Formik
} from 'formik';
import {
    FlexiButton,
    FlexiCancelButton,
    FormikPasswordInput,
    PlatformFieldset
} from "@flexinet/ui-components";
import {ChangePasswordRecordSchema} from "./RecordSchema.tsx";
import {useChangePasswordForm} from "../hooks/useChangePasswordForm.tsx";
import {useNavigate} from "react-router-dom";


const SubmitButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined }) =>
    <FlexiButton {...props} />

export const ChangePasswordForm = () => {
    const navigate = useNavigate();

    const {
        initialValues,
        handleSubmit,
    } = useChangePasswordForm();

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={ChangePasswordRecordSchema}
                onSubmit={handleSubmit}
            >
                {({
                      isSubmitting,
                  }) => (
                    <>
                        <Form>
                            <PlatformFieldset legend={'Change Password'}
                                              px={'xl'}
                                              mb={'xl'}>
                                <Field
                                    name="oldPassword"
                                    label="Current Password"
                                    type="password"
                                    description={<Text size={'0.8em'} fw={500}>Enter your current password</Text>}
                                    my={'lg'}
                                    component={FormikPasswordInput}
                                />

                                <Field
                                    name="newPassword"
                                    label="New Password"
                                    type="password"
                                    description={<Text size={'0.8em'} fw={500}>Min 8 characters. At least 1 number, 1
                                        special
                                        character,
                                        1 uppercase letter, 1 lowercase letter</Text>
                                    }
                                    my={'lg'}
                                    component={FormikPasswordInput}
                                />

                                <Field
                                    name="confirmPassword"
                                    label="Confirm New Password"
                                    type="password"
                                    description={<Text size={'0.8em'} fw={500}>Re-enter your new password</Text>}
                                    my={'lg'}
                                    component={FormikPasswordInput}
                                />

                                <Group justify={'flex-end'}>
                                    <FlexiCancelButton variant={'subtle'} onClick={() => navigate('/account')}/>
                                    <SubmitButton disabled={isSubmitting} type={'submit'}>Change
                                        Password</SubmitButton>
                                </Group>
                            </PlatformFieldset>
                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
};
